import colors from 'theme/colors'
import { isShortcodeExcludedForDriversDashboardAccess, isShortcodeEnabledForUnderwritersScoreDashboard } from 'tools/helper'
import strings from 'strings'

const TABS = strings.CARRIERS.TABS
const NBTABS = strings.CARRIERS.NBTABS
const PORTFOLIO_TABS = strings.CARRIERS.PORTFOLIO_TABS

const earnestMoneyStatus = [
  {
    label: 'All',
  },
  {
    label: 'New',
  },
  {
    label: 'Held',
    badgeColor: colors.warning,
  },
  {
    label: 'Approved',
    badgeColor: colors.success,
  },
  {
    label: 'Completed',
  },
  {
    label: 'Rejected',
    badgeColor: colors.error,
  },
]

const carriersTabs = [
  {
    label: 'My Carriers',
  },
  {
    label: 'Invited Carriers',
  },
]

const carriersForAgentsTabs = [
  {
    label: 'My Carriers',
  },
]

const connectedAccountsTabs = [
  {
    label: 'My Accounts',
  },
  {
    label: 'Invited Accounts',
  },
]

const userManagementStatus = [
  {
    label: 'All',
  },
  {
    label: 'Active',
  },
  {
    label: 'Inactive',
  },
]

const agentManagementStatus = [
  {
    label: 'All',
  }
]

const tagManagementStatus = [
  {
    label: 'All',
  }
]

const paymentsDetailTabs = [
  {
    label: 'Details',
  },
  {
    label: 'Notes',
  },
  {
    label: 'History',
  },
]

const dashboardTabs = [
  {
    label: 'Summary',
  },
  {
    label: 'Safety',
  },
  {
    label: 'Speed',
  },
  {
    label: 'Geographic',
  },
]

const reportingTabs = [
  {
    label: PORTFOLIO_TABS.MILEAGE_REPORTING,
  },
  {
    label: PORTFOLIO_TABS.LOCATION_REPORTING,
  },
  {
    label: PORTFOLIO_TABS.HEARTBEAT,
  },
  {
    label: PORTFOLIO_TABS.MILES_BY_ZIP,
  },
  {
    label: PORTFOLIO_TABS.RISK_DECILE,
  },
]

const fleetFileTabs = [
  {
    label: strings.FLEETFILE.TABS.RISK_SCORE,
  },
]

const carrierDetailsTabs = [
  ...(isShortcodeEnabledForUnderwritersScoreDashboard() ? [{
    label: TABS.NBI_TELEMATICS_SCORE,
  }] : []),
  {
    label: TABS.SUMMARY_REPORT,
  },
  {
    label: TABS.DETAILS,
  },
  {
    label: TABS.HEARTBEAT,
  },
  {
    label: TABS.HEARTBEAT_TRENDS
  },
  {
    label: TABS.MILEAGE_REPORTING
  },
  {
    label: TABS.LOCATION_REPORTING,
  },
  {
    label: TABS.MILES_BY_ZIP
  },
  {
    label: TABS.RADIUS_OF_OPERATION
  },
  {
    label: TABS.SAFETY_EVENTS
  },
  ...(!isShortcodeExcludedForDriversDashboardAccess()
    ? [
        {
          label: TABS.DRIVERS,
        },
      ]
    : []),
  {
    label: TABS.RISK_DECILE,
  },
]

const carrierDetailsNBTabs = [
  {
    label: NBTABS.NBI_TELEMATICS_SCORE,
  },
  {
    label: NBTABS.NB_DETAILS,
  },
  {
    label: NBTABS.NB_MILEAGE_REPORTING,
  },
  {
    label: NBTABS.NB_LOCATION_REPORTING,
  },
  {
    label: NBTABS.NB_MILES_BY_ZIP,
  },
  {
    label: NBTABS.NB_RADIUS_OF_OPERATION,
  },
  {
    label: NBTABS.NB_SAFETY_EVENTS,
  },
  {
    label: NBTABS.NB_DRIVERS,
  },
]

const fleetDetailsTabsForAgents = [
  {
    label: 'Details',
  },
  {
    label: 'Fleet Heartbeat',
  },
  {
    label: 'Fleet Percentiles'
  },
  {
    label: 'Fleet Miles By Zip'
  },
  {
    label: 'Safety Events'
  }
]

const fleetReportingTabs = [
  {
    label: 'Fleet Heartbeat',
  },
  {
    label: 'Fleet Percentiles'
  },
  {
    label: 'Fleet Details'
  },
  {
    label: 'Fleet Miles By Zip'
  },
  {
    label: 'Safety Events'
  }
]

const claimsMapLegendTabs = [
  {
    label: 'Safety Events',
  },
  {
    label: 'Routes',
  },
]

const carrierInviteStatus: any = {
  INVITED: {
    background: '#E1FAEB',
    color: '#20693D',
    label: 'Invited',
  },
  EXPIRED: {
    background: '#F5F7FA',
    color: '#707A8B',
    label: 'Expired',
  },
  VERIFICATION_FAILED: {
    background: '#FAF0F0',
    color: '#BA0D0D',
    label: 'Verification Failed',
  },
  REINVITED: {
    background: '#F0F5FC',
    color: '#1D5BBF',
    label: 'ReInvited',
  },
  IN_NETWORK: {
    background: '#E1FAEB',
    color: '#20693D',
    label: 'In Network',
  },
  NOT_IN_NETWORK: {
    background: '#F5F7FA',
    color: '#707A8B',
    label: 'Not In Network',
  },
}

const carrierStatus: any = {
  ACTIVE: {
    background: '#E1FAEB',
    color: '#20693D',
    label: 'Active',
  },
  DISCONNECTED: {
    background: '#FFF3E0',
    color: '#FB8C00',
    label: 'Disconnected',
  },
  PAUSED: {
    background: '#E3EEFB',
    color: '#1D5BBF',
    label: 'Paused',
  },
}

const vehicleStatus: any = {
  ACTIVE: {
    background: '#E1FAEB',
    color: '#20693D',
    label: 'Active',
  },
  INACTIVE: {
    background: '#FAF0F0',
    color: '#BA0D0D',
    label: 'Inactive',
  },
}

const teamVehicleStatus: any = {
  YES: {
    background: '#E1FAEB',
    color: '#20693D',
    label: 'Yes',
  },
  NO: {
    background: '#FAF0F0',
    color: '#BA0D0D',
    label: 'No',
  },
}

export const CARRIER_DETAILS_VIEW = {
  FLEET: 'fleet',
  INSURANCE: 'insurance',
} as const

export {
  earnestMoneyStatus,
  paymentsDetailTabs,
  userManagementStatus,
  carriersTabs,
  fleetDetailsTabsForAgents,
  carriersForAgentsTabs,
  connectedAccountsTabs,
  carrierInviteStatus,
  dashboardTabs,
  carrierDetailsTabs,
  reportingTabs,
  fleetFileTabs,
  fleetReportingTabs,
  agentManagementStatus,
  tagManagementStatus,
  claimsMapLegendTabs,
  carrierStatus,
  vehicleStatus,
  teamVehicleStatus,
  carrierDetailsNBTabs,
}
